import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Filter extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path
            d="M7.3,14.2l-1.2-0.6V7.1L1.6,2.7l0.5-1.3H14l0.5,1.3l-4.5,4.5v4.8l-0.3,0.6L7.3,14.2z M4,2.9l3.4,3.4l0.2,0.5
          v5.4l1-0.7V6.8l0.2-0.5l3.4-3.4H4z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Filter.js